module.exports = __webpack_public_path__ + "img/webnew49.e677532d.jpg";